import styled from 'styled-components'
import {
	media,
	textStyled,
	Breakpoints,
	ButtonGeneral,
} from 'Pages/landings/newLandings/common/style'
import {
	CheckboxComponent as CheckboxComponentDefault,
	InputComponent,
} from 'Pages/landings/newLandings/common/components'

export const StyledInnFormDescription = styled.p`
	${textStyled('SBSansInterface', 'regular', '16px', '24px', 'grey', 600)};
`

export const StyledInnFormText = styled.p`
	margin-top: 8px;
	margin-bottom: 16px;
	${textStyled('SBSansText', 'regular', '16px', '24px', 'grey', 600)};
`

export const StyledInnFormTextHref = styled.a`
	${textStyled('SBSansInterface', 'regular', '16px', '24px', 'brand', 500)};
	text-decoration: none;
`

export const CheckboxText = styled.p`
	margin-left: 8px;
	${textStyled('SBSansInterface', 'regular', '16px', '24px', 'grey', 700)};
`
export const Button = styled(ButtonGeneral)`
	width: 100%;
	${media('width: 464px;', Breakpoints.ms)}
`

export const CheckboxComponent = styled(CheckboxComponentDefault)`
	grid-column: 1;
	position: relative;
	top: 14px;
`
export const Input = styled(InputComponent)`
	margin-bottom: 16px;
`
export const BtnWrapper = styled.div`
	margin-top: 32px;
	display: flex;
	gap: 16px;
	justify-content: flex-end;
`

export const GridMiddleName = styled.div`
	grid: repeat(1, 48px) / 1fr;
	${media('display: block;', Breakpoints.sm)};
	${media('display: flex;', Breakpoints.ms)};
	align-items: flex-start;
	gap: 16px;
	margin-bottom: 16px;

	${Input} {
		flex-grow: 2;
		margin-bottom: 0px;
	}
`

export const GridHalf = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 16px;
	${media('column-gap: 16px; grid: 48px / repeat(2, 1fr);', Breakpoints.ms)};
	${Input} {
		flex-grow: 1;
	}
`
export const WrapperCheckbox = styled.div`
	height: 48px;
`
